import moment from "moment";
import constants from "../../../core/constants";

class SkipStationDialogController {
  constructor(station, ride, $mdDialog, Bookings, Events, User) {
    "ngInject";

    this.station = station;
    this.ride = ride;
    this.$mdDialog = $mdDialog;
    this.Bookings = Bookings;
    this.Events = Events;
    this.User = User;

    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.checkingBookings = true;
  }

  $onInit() {
    this.Bookings.getAll({
      isCityRequired: false,
      status: "booked",
      pick_up: this.station._id,
      ride: this.ride._id.value,
    }).$promise.then((response) => {
      const getSource = (item) => ({ ...item._source, _id: item._id });

      this.checkingBookings = false;
      this.availableBookings = response.hits.map(getSource);
      if (this.availableBookings.length === 0) {
        this.confirm();
      } else {
        this.unhandledBookings = this.availableBookings.length;
      }
    });
  }

  _constructConfirm(title, textContent = "") {
    return this.$mdDialog
      .confirm()
      .multiple(true)
      .title(title)
      .textContent(textContent)
      .ok("Confirm")
      .cancel("Cancel");
  }

  checkInCustomer(booking) {
    const confirm = this._constructConfirm(
      "Are you sure you want to check-in this customer?"
    );

    this.$mdDialog.show(confirm).then(() => {
      this.Bookings.checkIn(booking._id).$promise.then(
        () => {
          booking.status = "Checked-In";
          this.unhandledBookings--;
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    });
  }

  cancelBooking(booking) {
    let topUpValue = 0;
    let textContent = "";
    const { currency } = this.ride.route.city;

    const rideCategory = this.ride.route.city.ride_categories.find(
      ({ category }) => category === this.ride.ride_category._id
    );

    const topUp = rideCategory.features.find(({ name }) => name === "top_up");
    if (topUp) topUpValue = topUp.value;
    if (topUpValue) {
      textContent = `If yes your customer will have a topup of ${
        topUpValue / constants.currencyBy
      } ${currency}`;
    }

    const confirm = this._constructConfirm(
      "Are you sure you want to cancel, refund and top-up this customer?",
      textContent
    );

    const topUpCustomer = () => {
      const expiryDate = Number(
        moment().add(7, "days").format(constants.unixFormat)
      );
      this.User.updateAction(booking.user._id, "topup", {
        amount: topUpValue,
        currency,
        comment: `Topup due to skip station ${this.station.name}`,
        type: "topup",
        expiry_date: expiryDate,
      }).$promise.then(
        () => {
          booking.status = "Cancelled";
          this.unhandledBookings--;
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    };

    this.$mdDialog.show(confirm).then(() => {
      const requestBody = { refund_percentage: constants.refundPercentage };

      this.Bookings.cancel(booking._id, requestBody).$promise.then(
        () => {
          if (topUpValue) {
            topUpCustomer();
          } else {
            booking.status = "Cancelled";
            this.unhandledBookings--;
          }
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    });
  }

  markCustomerAsMissed(booking) {
    const confirm = this._constructConfirm(
      "Are you sure you want to mark this customer as missed?"
    );

    this.$mdDialog.show(confirm).then(() => {
      this.Bookings.miss(booking._id).$promise.then(
        () => {
          booking.status = "Missed";
          this.unhandledBookings--;
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    });
  }

  close() {
    this.$mdDialog.cancel();
  }

  canConfirm() {
    return this.unhandledBookings === 0;
  }

  confirm() {
    this.$mdDialog.hide();
  }
}

export default SkipStationDialogController;



// WEBPACK FOOTER //
// ./src/components/stationsTimeline/skipStationDialog/skipStationDialog.controller.js